// Copyright ©️ 2026 eVolve MEP, LLC

import type { BendTypeName } from '@evolvemep/api-ts';

type BendTypeGlyph = {
  /** SVG path data in a 64 × 32 view box, stroked. */
  path: string;
  /** When true, the path is drawn mirrored left to right, for the Left variant of a directional bend. */
  mirrored?: boolean;
};

export type OfferedBendTypeName = Exclude<BendTypeName, 'Custom'>;

/** Line drawings of each bend type for the Bend Type step's tiles, from the v15 prototype. `Custom` is not offered. */
export const bendTypeGlyphs: Record<OfferedBendTypeName, BendTypeGlyph> = {
  'Angled': { path: 'M2 28H34L62 8' },
  'Stub 90': { path: 'M2 30H40Q52 30 52 18V2' },
  'Kick 90 Left': { path: 'M2 30H40Q50 30 50 20V12L58 3', mirrored: true },
  'Kick 90 Right': { path: 'M2 30H40Q50 30 50 20V12L58 3' },
  'Offset': { path: 'M2 27H22L42 5H62' },
  '3-Point Saddle': { path: 'M2 28H18L32 8L46 28H62' },
  '4-Point Saddle': { path: 'M2 28H15L25 7H39L49 28H62' },
  'Offset Back to Back': { path: 'M2 28H10L20 10H44L54 28H62' },
  'Kick 90 Back to Back Right': { path: 'M4 2V14Q4 26 14 26H48Q56 26 56 16V11L62 3' },
  'Kick 90 Back to Back Left': { path: 'M4 2V14Q4 26 14 26H48Q56 26 56 16V11L62 3', mirrored: true },
};

export const isOfferedBendType = (name: BendTypeName): name is OfferedBendTypeName => name !== 'Custom';
